// extracted by mini-css-extract-plugin
export default {"page":"Terms_page__tMl0d","content":"Terms_content__qrtpD","header":"Terms_header__M0TA9","box":"Terms_box__4-+H5"};